import React from 'react';
import { Portal } from '../../../components/Portal/component';
import { ConnectedInstitutionSettingsFrontChat } from './connector';

export const InstitutionSettingsFrontChatPortal: React.FC = () => (
  <Portal id="institution-admin-front-chat-mount">
    <ConnectedInstitutionSettingsFrontChat />
  </Portal>
);
